import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { useContext } from "react";
import { PitchContext } from "../context/PitchContex";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const {
    navigate,
    setUser,
    setToken,
    backendURL,
    setAlertMessage,
    setIsErr,
    setShowAlert,
    setPending,
  } = useContext(PitchContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPending(true);
    axios
      .post(backendURL + "user/login", {
        email,
        password,
      })
      .then((response) => {
        setPending(false);
        if (response.data.success) {
          setToken(response.data.token);
          setUser(response.data.user);
          localStorage.setItem("user", JSON.stringify(response.data.user));
          localStorage.setItem("token", response.data.token);
          navigate("/");
        } else {
          setIsErr(true);
          setAlertMessage(response.data.message);
          setShowAlert(true);
        }
      })
      .catch((err) => {
        setPending(false);
        setIsErr(true);
        setAlertMessage(err.response.data.message);
        setShowAlert(true);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="my-10 sm:my-0 sm:min-h-screen flex items-center justify-center bg-gray-100">
      <div className="flex flex-col md:flex-row w-full max-w-6xl bg-white rounded-xl shadow-lg overflow-hidden">
        {/* Sol Resim Bölümü */}
        <img
          className="w-full md:w-1/2 h-64 md:h-auto object-cover rounded-t-xl md:rounded-t-none md:rounded-l-xl hidden md:flex"
          src="/reduced-logo.webp"
          alt="Giriş illüstrasyonu"
        />

        {/* Sağ Form Bölümü */}
        <div className="w-full md:w-1/2 p-8">
          <div className="flex items-center justify-center gap-2 mb-6">
            <h1 className="text-2xl font-extrabold tracking-tight">
              H
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                A
              </span>
              L
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                I
              </span>
              S
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                A
              </span>
              H
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                A
              </span>
              B
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                U
              </span>
              L
            </h1>
          </div>

          <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">
            Hesabınıza Giriş Yapın
          </h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                E-posta
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
                placeholder="E-postanızı girin"
              />
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700"
              >
                Şifre
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
                placeholder="Şifrenizi girin"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-[#4d9041] text-white py-2 rounded-md hover:bg-[#62a556] transition-colors duration-300 font-medium cursor-pointer"
            >
              Giriş Yap
            </button>
          </form>

          <div className="flex justify-between">
            <Link
              to="/sifremi-unuttum"
              className=" mt-4 text-center text-sm  text-[#4d9041] hover:underline font-medium"
            >
              Şifre Yenile
            </Link>

            <p className="mt-4 text-center text-sm text-gray-600">
              Hesabınız yok mu?{" "}
              <Link
                to="/kayit-ol"
                className="text-[#4d9041] hover:underline font-medium"
              >
                Buradan kaydolun
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
